import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAsset } from "../../actions/assetAction";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { useNavigate } from "react-router";
import {
  getSecurityType,
  getInvestmentStatus,
  getAssetClass,
  getFundStatus,
  getPrimaryAnalyst,
  getSecondaryAnalyst,
  getStrategy,
  getSubStrategy,
  getRegion,
  getSubRegion,
  getSector,
  getSubSector,
} from "../../actions/assetDetailsActions";
import { getManagerContacts } from "../../actions/CommonAction";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBATextBox } from "../../UiComponents/SBATextBox";
import { UrlPath } from "../../../config/routeConfig";
import "./AssetEdit.css";
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from 'react-toastify';
import $ from 'jquery';
import moment from "moment";
import { useLocation } from 'react-router-dom';
import { InsertorUpdateAsset } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";

export const AssetAdd = () => {
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const location =useLocation();

  const [selectedSecurityTypeId, setSelectedSecurityTypeId] = useState();
  const [selectedSecurityType, setSelectedSecurityType] = useState();
  const [selectedAssetClassId, setSelectedAssetClassId] = useState();
  const [selectedAssetClass, setSelectedAssetClass] = useState(null);
  const [selectedStrategyId, setSelectedStrategyId] = useState(null);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [selectedSubStrategyId, setSelectedSubStrategyId] = useState(null);
  const [selectedSubStrategy, setSelectedSubStrategy] = useState(null);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedInvestmentStatusId, setSelectedInvestmentStatusId] = useState(null);
  const [selectedInvestmentStatus, setSelectedInvestmentStatus] = useState(null);
  const [selectedSubRegionId, setSelectedSubRegionId] = useState();
  const [selectedSubRegion, setSelectedSubRegion] = useState();
  const [selectedAssetStatusId, setSelectedAssetStatusId] = useState(null);
  const [selectedAssetStatus, setSelectedAssetStatus] = useState(null);
  const [selectedSectorId, setSelectedSectorId] = useState(null);
  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedPrimaryAnalystId, setSelectedPrimaryAnalystId] = useState(null);
  const [selectedPrimaryAnalyst, setSelectedPrimaryAnalyst] = useState(null);
  const [selectedSubSectorId, setSelectedSubSectorId] = useState();
  const [selectedSubSector, setSelectedSubSector] = useState();
  const [selectedSecondaryAnalystId, setSelectedSecondaryAnalystId] = useState(null);
  const [selectedSecondaryAnalyst, setSelectedSecondaryAnalyst] = useState(null);
  const [selectedAssetName, setSelectedAssetName] = useState('');
  const [selectedAbbreviationName, setSelectedAbbreviationName] = useState('');
  const [selectedEffectiveDate, setSelectedEffectiveDate] = useState(new Date());
    const [selectedStrategyDescription, setSelectedStrategyDescription] = useState('');
    const [selectedManager, setSelectedManager] = useState();
    const [selectedManagerId, setSelectedManagerId] = useState('');
    const [resulttrim, setResulttrim] = useState();
    const [trimAberivation, settrimAberivation] = useState();
   
    


  useEffect(() => {

    dispatch(getSecurityType());
    dispatch(getInvestmentStatus());
    dispatch(getAssetClass());
    dispatch(getFundStatus());
    dispatch(getPrimaryAnalyst());
    dispatch(getSecondaryAnalyst());
    dispatch(getStrategy());
    dispatch(getSubStrategy());
    dispatch(getRegion());
    dispatch(getSubRegion());
    dispatch(getSector());
      dispatch(getSubSector());
      dispatch(getManagerContacts());
  }, []);
  const history = useNavigate();

  const Level = [
    { BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` },
    { BreadCrumb: "Add", Routes: `${UrlPath.AssetEdit}${params.Asset}` },
  ];
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  const securityType = Gstate.assetSecurityType.assetSecurityType;

  const investmentStatus = Gstate.assetInvestStatus.assetInvestStatus;
  const assetclass = Gstate.assetClass.assetClass;

  const fundstatus = Gstate.fundStatus.fundStatus;
  const primaryanalyst = Gstate.primaryAnalyst.primaryAnalyst;
  const secondaryanalyst = Gstate.secondaryAnalyst.secondaryAnalyst;
  const Strategy = Gstate.strategy.strategy;
  const SubStrategy = Gstate.subStrategy.subStrategy;
  const Region = Gstate.region.region;
  const SubRegion = Gstate.subregion.subregion;
  const Sector = Gstate.sector.sector;
    const Subsector = Gstate.subsector.subsector;
    const manager = Gstate.managerContacts.managerContacts;

  const CancelButtonClick = () => {
    if(location?.state?.ActiveTab==="AssetList" || location.state===null)
    {
      history(`${UrlPath.Asset}`);
    }
    else if(location.state.ActiveTab==="AssetDetails")
    {
      const preSelectedAssetID=parseInt(location.state.currentAssetId);
      history(`${UrlPath.AssetDetails}${preSelectedAssetID}`);
    }
  };
     
  useEffect(() => {
    document.title = "Asset Add";
  }, []);
  useEffect(() => {
    setLoading(false);
    setSelectedAssetStatusId(fundstatus[0]?.AssetStatusId);
    setSelectedAssetStatus(fundstatus[0]?.AssetStatus);
  }, [Gstate]);

  const securityDropdownChange = (e) => {
      if (e.value) {
          setSelectedSecurityTypeId(e.value.AssetTypeId)
          setSelectedSecurityType(e.value.AssetTypeName);
      }
    
    };
    const managerDropdownChange = (e) => {
        if (e.value) {
            setSelectedManagerId(e.value.ManagerContactId);
            setSelectedManager(e.value.ManagerContact);
        }
    };
    const assetclassDropdownChange = (e) => {
        if (e.value) {
            setSelectedAssetClassId(e.value.ClassificationId);
            setSelectedAssetClass(e.value.ClassificationValue);
        }
  };
    const strategyDropdownChange = (e) => {
        if (e.value) {
            setSelectedStrategyId(e.value.ClassificationId);
            setSelectedStrategy(e.value.ClassificationValue);
        }
  };
  const subStrategyDropdownChange = (e) => {
    setSelectedSubStrategyId(e.value.ClassificationId);
    setSelectedSubStrategy(e.value.ClassificationValue);
  };
    const regionDropdownChange = (e) => {
        if (e.value) {
            setSelectedRegionId(e.value.ClassificationId);
            setSelectedRegion(e.value.ClassificationValue);
        }
  };
  const investmentStatusDropdownChange = (e) => {
    setSelectedInvestmentStatusId(e.value.EnumValue);
    setSelectedInvestmentStatus(e.value.EnumName);
  };
    const subRegionDropdownChange = (e) => {
        if (e.value) {
            setSelectedSubRegionId(e.value.ClassificationId);
            setSelectedSubRegion(e.value.ClassificationValue);
        }
  };
    const assetStatusDropdownChange = (e) => {
        if (e.value) {
            setSelectedAssetStatusId(e.value.AssetStatusId);
            setSelectedAssetStatus(e.value.AssetStatus);
        }
  };
    const sectorDropdownChange = (e) => {
        if (e.value) {
            setSelectedSectorId(e.value.ClassificationId);
            setSelectedSector(e.value.ClassificationValue);
        }
  };
    const primaryAnalystDropdownChange = (e) => {
        if (e.value) {
            setSelectedPrimaryAnalystId(e.value.UserId);
            setSelectedPrimaryAnalyst(e.value.AnalystName);
        }
  };
    const subsectorDropdownChange = (e) => {
        if (e.value) {
            setSelectedSubSectorId(e.value.ClassificationId);
            setSelectedSubSector(e.value.ClassificationValue);
        }
  };
    const secondaryAnalystDropdownChange = (e) => {
        if (e.value) {

            setSelectedSecondaryAnalystId(e.value.UserId);
            setSelectedSecondaryAnalyst(e.value.AnalystName);
        }
  };
   
    const assetNameChange = (event) => {
        const result = SBATextBox(event.target.value)
        setResulttrim(result);
       setSelectedAssetName(event.target.value);
  };
    const abbreviationChange = (event) => {
        const result = SBATextBox(event.target.value)
        settrimAberivation(result);
       setSelectedAbbreviationName(event.target.value);
  };
    const effectiveDateChange = (newDate) => {
   // setSelectedEffectiveDate(new Date(moment(selected.value).format('MM/DD/YYYY')));
     //   setSelectedEffectiveDate(new Date(selected.value));
        setSelectedEffectiveDate(newDate);
  };
  const StrategyDescChange = (event) => {
    setSelectedStrategyDescription(event.target.value);
  };

    const addAssetDetails = (event) => {
    event.preventDefault();
    let saveSuccess = true;
    let errorMsg = [];
    // Prepare the data to be sent in the POST request
    const data = {
      "assetId": 0,
      "securityTypeId": selectedSecurityTypeId,
      "securityType": selectedSecurityType,
      "assetClassId": selectedAssetClassId,
      "assetClass": selectedAssetClass,
      "strategyId": selectedStrategyId,
      "strategy": selectedStrategy,
      "substrategyId": selectedSubStrategyId,
      "substrategy": selectedSubStrategy,
      "regionId": selectedRegionId,
      "region": selectedRegion,
      "investmentStatusId": selectedInvestmentStatusId,
      "investmentStatus": selectedInvestmentStatus,
      "subregionId": selectedSubRegionId,
      "subregion": selectedSubRegion,
      "assetStatusId": selectedAssetStatusId,
      "assetStatus": selectedAssetStatus,
      "sectorId": selectedSectorId,
      "sector": selectedSector,
      "primaryAnalystId": selectedPrimaryAnalystId,
      "primaryAnalyst": selectedPrimaryAnalyst,
      "subSectorId": selectedSubSectorId,
      "subSector": selectedSubSector,
      "secondaryAnalystId": selectedSecondaryAnalystId,
      "secondaryAnalyst": selectedSecondaryAnalyst,
      "assetName": selectedAssetName,
      "abbrName": selectedAbbreviationName,
      "effectiveDate": selectedEffectiveDate,
       "StrategyDescription": selectedStrategyDescription,
        "managerContactId": selectedManagerId,
    };
     if((resulttrim == false) || (selectedAssetName.length==0)) {
      saveSuccess = false;
      errorMsg.push("Please Enter Asset Name");
    }
     else if ((trimAberivation == false)||(selectedAbbreviationName.length === 0))  {
      saveSuccess = false;
      errorMsg.push("Please Enter Abbreviation Name");
    }
    else if (!selectedSecurityTypeId) {
      saveSuccess = false;
      errorMsg.push("Please select Security Type");
    }
    else if (!selectedStrategyId) {
      saveSuccess = false;
      errorMsg.push("Please select Strategy");
    }
        if (saveSuccess) {
            sbaAxios({
                url: `${InsertorUpdateAsset}`,
                method: 'post',
                data: data,
            }).then((response) => {
                if (response > 0) {
                    toast.success('Asset Saved Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    setTimeout(() => {
                        history(`${UrlPath.AssetDetails}${response}`);
                    }, 1000);
                }
                else if (response = -999) {
                    toast.error('Asset name  Already Exists',{
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                }
                   
                   

                })
        

        .catch((error) => {
          console.error(error);
        });
    }
    else {
      let ErrorString = "";
      errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
      console.log(errorMsg);
      toast.error(ErrorString, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  };
  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          <TopBar label={"Asset Add"} />
          <BreadCrumbs Levels={Level} />
          <div id="content" class="asset-detail-screen mainContentData">
            <div class="p-4">
              <div class="d-flex align-items-center justify-content-between my-2 flex-wrap flex-lg-nowrap">
              </div>

              <div id="manfield" className="p-3 mb-4 bg-white life-science rounded">
              <div className="row ">
                    <div className="col-md-4">
                      <div className="my-4">
                        <label className="label">Asset Name<span className="mandatory">*</span></label>
                        <input
                                className="form-control w-75"
                                type="text"
                                onChange={assetNameChange}
                                required
                              />
                      </div>
                      <div className="my-4">
                        <label className="label">Abbreviation Name<span className="mandatory">*</span></label>
                        <input
                                className="form-control w-75"
                                type="text"
                                onChange={abbreviationChange}
                                required
                              />
                                          </div>
                                           
                      <div  className="my-4">
                        <label className="label">Asset Manager</label>
                                              <div> <SBAComboBox
                                                  className="w-75"
                                                  data={manager}

                                                  textField={"ManagerContact"}
                                                  valueField={"ManagerContactId"}
                                                  onChange={managerDropdownChange}

                                              />
                                              </div> </div>
                      <div className="my-3">
                        <label className="label">Security Type<span className="mandatory">*</span></label>
                        <div>
                             <SBAComboBox
                                className="w-75"
                                data={securityType}
                             
                                textField={"AssetTypeName"}
                                valueField={"AssetTypeId"}
                                onChange={securityDropdownChange}

                              />
                        </div>
                        
                      </div>
                      <div className="my-4">
                        <label className="label">Inception Date	</label>
                        <div>
                                                  {/*<SBDatePicker className="w-75" id="txtEffectiveDate" value={moment(selectedEffectiveDate)} onChange={effectiveDateChange}>*/}
                                                  {/*</SBDatePicker>*/}
                                                  <SBDatePicker className="w-75" value={moment(selectedEffectiveDate)} onChange={effectiveDateChange} />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Investment Status</label>
                        <div>
                            <SBAComboBox
                            className='w-75'
                            textField={"EnumName"}
                            valueField={"EnumValue"}
                            data={investmentStatus}
                            onChange={investmentStatusDropdownChange}
                          />
                        </div>
                      </div>
                      <div className="my-4" >
                        <label className="label">Asset Status	</label>
                        <div>
                          <SBAComboBox
                        className='w-75'
                                textField={"AssetStatus"}
                                valueField={"AssetStatusId"}
                                data={fundstatus}

                                onChange={assetStatusDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4" >
                        <label className="label">Primary Analyst</label>
                        <div>
                         <SBAComboBox
                          className="w-75"
                            textField={"AnalystName"}
                            valueField={"UserId"}
                            data={primaryanalyst}
                            onChange={primaryAnalystDropdownChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="my-4">
                        <label className="label">Secondary Analyst</label>
                        <div style={{width:"75%"}}>
                            <SBAComboBox
                                Name="w-50"
                                textField={"AnalystName"}
                                valueField={"UserId"}
                                data={secondaryanalyst}

                                onChange={secondaryAnalystDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Asset Class</label>
                        <div>
                       <SBAComboBox
                        className="w-75"
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={assetclass}
                                onChange={assetclassDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Strategy <span className="mandatory">*</span></label>
                        <div>
                             <SBAComboBox
                                className='w-75'
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={Strategy}

                                onChange={strategyDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Sub Strategy	</label>
                        <div>
                           <SBAComboBox
                        className="w-75"
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={SubStrategy}

                                onChange={subStrategyDropdownChange}
                              />
                        </div>
                        
                      </div>
                      <div className="my-4">
                        <label className="label">Sector</label>
                        <div>
                        <SBAComboBox
                        className="w-75"
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={Sector}
                                autosize={false}
                                onChange={sectorDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Sub Sector	</label>
                        <div>
                             <SBAComboBox
                        className="w-75"
                              textField={"ClassificationValue"}
                              valueField={"ClassificationId"}
                              data={Subsector}

                              onChange={subsectorDropdownChange}
                            />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Region</label>
                        <div>
                          <SBAComboBox
                        className="w-75"
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={Region}

                                onChange={regionDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Classification</label>
                        <div>
                           <SBAComboBox
                        className="w-75"
                         textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={SubRegion}

                                onChange={subRegionDropdownChange}
                              />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                    <span style={{ marginLeft: "2%", fontWeight: "bold" }}>Strategy Description</span>
                      <textarea style={{ marginLeft: "2%" }} id="txtStrategydesc" className="form-control" rows={7}  onChange={StrategyDescChange} ></textarea>
                    </div>
                </div>              
              </div>
              <div className="col-lg-12 px-3 m-3 d-flex justify-content-end">
                  <button className="s-sm-btn" onClick={CancelButtonClick}> Cancel</button>
                  <button className='ms-2 p-sm-btn' onClick={addAssetDetails}>Save</button>
              </div>

            </div>
          </div>
          <ToastContainer></ToastContainer>
        </>
      )}
    </div>
  );
};
